// extracted by mini-css-extract-plugin
export default {"noScroll":"UI_noScroll__YFUB4","circle":"UI_circle__hkK0X","divider":"UI_divider__v7754"};